var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3754 5.72202L9.87762 13.9433C8.432 14.5858 7.49461 16.0286 7.52641 17.6102C7.92154 37.2607 12.8256 44.1482 27.9148 53.7015C29.1847 54.5055 30.8164 54.5071 32.0868 53.7039C47.2706 44.1039 51.9302 37.0612 52.4543 17.6319C52.4973 16.0395 51.5583 14.5814 50.1026 13.9345L31.6246 5.72202C30.5903 5.26235 29.4097 5.26235 28.3754 5.72202Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30L28.0028 34.4023C28.4207 34.7366 29.0277 34.6826 29.3801 34.2799L37.5 25",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.fd1185264977ccddfb0eed635d4b60eb.svg";
export { ForwardRef as ReactComponent };